import React, {useEffect, useState, useRef} from "react";
import {useNavigate} from  "react-router-dom";
import EPStyles from "../styles/pages/EvaluatorPanel.module.css";
import {talk} from "../ALI_Ajax.js";
import {useUser} from "../UserContext";
import LoginModule from "../login_module";
import JsonViewer from "../components/JsonViewer";
import CompletedTestViewer from "../components/CompletedTestViewer";

const EvaluatorPanel = () => {
    const {userId, finishedLoggingIn, is_user_in_role} = useUser();
    const navigate = useNavigate();
    const [completedTests, setCompletedTests] = useState([]);
    const [selectedTest, setSelectedTest] = useState(null);

    const loadCompletedTests = () => {
        talk("ali_api/handlers/TestHandler.php",
            "LOAD_COMPLETED_TEST_SESSIONS",
            null,
            loadCompletedTestsHandler);
    }
    const loadCompletedTestsHandler = (operation, sentData, returnData) => {
        if(returnData['status'] !== 'success') {
            console.log("ERROR loading saved test sessions.");
            console.log(returnData);
            setCompletedTests([]);
            return;
        }

        console.log(returnData['data']);

        setCompletedTests(returnData['data']);
    }


    if(finishedLoggingIn && is_user_in_role('ADMIN')) {
        return (
            <div className={EPStyles.container}>
                <h1 className={EPStyles.heading}>Test Evaluator Panel</h1>
                <p className={EPStyles.subtext}>
                    This is a placeholder for the evaluator interface. Features and tools
                    for evaluating student tests will appear here.
                </p>

                <div className={EPStyles.card}>
                    <h2 className={EPStyles.cardTitle}>Evaluator Dashboard</h2>
                    <p className={EPStyles.cardBody}>
                        This section will display student submissions, evaluation rubrics, and
                        scoring tools.
                    </p>
                    <div><button onClick={loadCompletedTests}>Load Completed Tests</button></div>
                </div>

                {/* Completed Tests Table */}
                <div className={EPStyles.section}>
                    <h2 className={EPStyles.sectionTitle}>Completed / Saved Test Sessions</h2>

                    {(!completedTests || completedTests.length === 0) ? (
                        <div className={EPStyles.emptyState}>
                            No completed tests found.
                        </div>
                    ) : (
                        <div className={EPStyles.tableWrap}>
                            <table className={EPStyles.table}>
                                <thead>
                                <tr>
                                    <th className={EPStyles.sessionIdCell}>Session ID</th>
                                    <th>Examinee</th>
                                    <th>Test Started</th>
                                    <th>Test Ended</th>
                                    <th>Section</th>
                                    <th>Last Saved</th>
                                    <th>Test ID</th>
                                    <th>State JSON</th>
                                </tr>
                                </thead>
                                <tbody>
                                {completedTests.map((t) => (
                                    <tr
                                        key={t.session_id}
                                        onClick={() => {console.log(t); setSelectedTest(t)}}
                                    >
                                        <td className={`${EPStyles.mono} ${EPStyles.sessionIdCell}`}>{t.session_id}</td>
                                        <td>{t.firstname} {t.lastname} ({t.examinee_id})</td>
                                        <td>{t.test_started_at ?? ""}</td>
                                        <td>{t.test_ended_at ?? ""}</td>
                                        <td>{t.test_section ?? ""}</td>
                                        <td>{t.last_saved_at ?? ""}</td>
                                        <td className={EPStyles.mono}>{t.test_id ?? ""}</td>
                                        <td className={EPStyles.jsonCell}>
                                            <pre><JsonViewer data={t.state_json} indent="2" /></pre>
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>

                {/* Selected Test Viewer */}
                {selectedTest ? (
                    <div className={EPStyles.section}>
                        <h2 className={EPStyles.sectionTitle}>Completed / Saved Test Sessions</h2>
                        <CompletedTestViewer selectedTest={selectedTest} />
                    </div>
                ) : ""}

            </div>
        );
    } else {
        navigate("/");
    }
};

export default EvaluatorPanel;
